export const translationsEn = {
    categories: "Categories",
    findBlog: "Find blog",
    day: "day",
    week: "week",
    month: "month",
    notValid: "The following is not valid:",
    fillFields: "Fill in all required fields to continue",
    oldPassword: "Old password",
    optional: "Optional",
    or: "or",
    password: "Password",
    passwordCharacters: "Password must be 8 characters long",
    passwordLink1: "Enter your email address and we will sent you a magic link from where you will update your password.",
    passwordLink2: "Password update link has been sent to your email.",
    passwordLink3: "Check in your inbox from Veli and follow the link, please note that it might have gone to your spam folder.",
    passwordMinimumLength: "Minimum length is 8",
    passwordNotMatch:  "Passwords do not match",
    passwordRemember: "Remember your password?",
    passwordRequired: "Password is required",
    passwordUpdated: "You have updated your password",
    edit: "edit",
    email: "Email",
    emailNotValid: "Email is not valid",
    emailRequired: "Email is required",
    fullNameCharacters1:"Full name must be at least 2 characters long",
    fullNameCharacters2:"Full name must be less than 30 characters long",
    fullNameRequired:"Full name is required",
    fullNameInvalidCharacters: "Include only Symbols, Georgian and English letters",
    back: "Back",
    updateYourPassword: "update your password",
    sendAgain: "send again",
    sendMeLink: "send Me Link",
  

  };